import { useLayoutEffect } from 'react'

import RadioXl from '../../../common/forms/Radio/RadioXl.tsx'

type Props = {
  daymenusSelected: string | null
  setDaymenus: (daymenus: string | null) => void
  resetFilters: () => void
}

const DaymenusDropdown = (props: Props) => {
  const { daymenusSelected, setDaymenus, resetFilters } = props

  useLayoutEffect(() => {
    setDaymenus('global')
  }, [])

  const onChangeHanler = (e: any) => {
    resetFilters()
    setDaymenus(e)
  }

  return (
    <div
      className={
        'flex items-center p-5 flex-col justify-center gap-x-4 border-t-2 border-gray-200 dark:border-gray-600'
      }
    >
      <p className={'text-xl text-black dark:text-white font-medium pb-3'}>
        Baza diet:{' '}
      </p>
      <div className={'flex flex-col md:flex-row gap-x-4 gap-y-2'}>
        <RadioXl
          id={'radio-xl-1'}
          name={'radio-group'}
          value={'global'}
          label={'Globalna'}
          checked={daymenusSelected === 'global'}
          onChange={(e) => onChangeHanler(e)}
        />
        <RadioXl
          id={'radio-xl-2'}
          name={'radio-group'}
          value={'dietitian'}
          label={'Własna'}
          checked={daymenusSelected === 'dietitian'}
          onChange={(e) => onChangeHanler(e)}
        />
      </div>
    </div>
  )
}

export default DaymenusDropdown
